import React from "react";
import ReactDOM from "react-dom/client";
import App from "./routes";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Render your app
root.render(<App />);
